// General constants for the My Emergency Plan feature
export const myEmergencyPlanFormTotalSteps = 8;
export const myEmergencyPlanFormFirstStageId = 'G2';
export const myEmergencyPlanFormLastStageId = 'REF41';
export const myEmergencyPlanRegisterEventDefaultComment =
  'I am interested to learn more about how I can prepare for emergencies in my area.';
